import { sendJsonStatistics, StatisticData } from "@/services/statistics.service";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import store from "..";
import { UPDATE_STATISTICS, SEND_JSON_STATISTICS } from "../operators";

/**
 * This module contains the statistiques to send to studio.
 */
@Module
export class StatisticsState extends VuexModule {
  // State variables
  public statistics: StatisticData[] = [];

  @Mutation
  public [UPDATE_STATISTICS](statistic: StatisticData): void {
    this.statistics.push(statistic);
  }

  /**
   * @param payload
   */
  @Action
  public [SEND_JSON_STATISTICS](payload: StatisticData): void {
    store.commit(UPDATE_STATISTICS, payload);
    sendJsonStatistics(payload).catch(() => undefined);
  }
}
